import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import Icon from '../../Icon';
import styles from './index.styl';

function CardIcon({ icon, size, title, subtitle, info, withBg, onClick }) {
  return (
    <div
      className={cn(styles.root, {
        [styles.withBg]: withBg,
      })}
      onClick={onClick}
    >
      <div className={styles.container}>
        <Icon name={icon} size={size} className="mr2 flex-shrink-0" />
        <div className={styles.desc}>
          <div className={styles.heading}>
            <div className={styles.subtitle}>{subtitle}</div>
            <div className={styles.title}>{title}</div>
          </div>
          <div className={styles.info}>{info}</div>
        </div>
      </div>
    </div>
  );
}

CardIcon.defaultProps = {
  size: 36,
};

CardIcon.propTypes = {
  icon: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  info: PropTypes.string,
  withBg: PropTypes.bool,
  onClick: PropTypes.func,
};

export default CardIcon;



// WEBPACK FOOTER //
// ./src/components/common/CardIcon/index.jsx